import React from "react";
import { MapPin, Phone, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "../LanguageContext";
import { translations } from "../translations";

const Footer = () => {
  const { language } = useLanguage();

  return (
    <footer className="w-full bg-gray-900 text-gray-300 py-10 px-6">
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-4 gap-8">
        {/* Contact Info */}
        <div className="md:col-span-1">
          <h3 className="text-lg font-semibold mb-4">
            {translations[language].ContactUs}
          </h3>
          <div className="space-y-4">
            <div className="flex items-start">
              <MapPin className="text-red-700 w-5 h-5 mr-3 flex-shrink-0" />
              <p>
                {translations[language].GoldenGateTower} <br />
                {translations[language].UpperPazuntaung} <br />
                {translations[language].Mingalartaungnyunt}
              </p>
            </div>
            <div className="flex items-center">
              <Phone className="text-red-700 w-5 h-5 mr-3" />
              <p>
                {translations[language].Ph1} <br /> {translations[language].Ph2}
              </p>
            </div>
            <div className="flex items-center">
              <Mail className="text-red-700 w-5 h-5 mr-3" />
              <p>contact@mcbwi.com</p>
            </div>
          </div>
        </div>

        {/* Sitemap */}
        <div className="md:col-span-1  ">
          <h3 className="text-lg font-semibold mb-4">
            {translations[language].Sitemap}
          </h3>
          <ul className="space-y-2">
            <li>
              <Link to="/" className="hover:text-red-700">
                {translations[language].Home}
              </Link>
            </li>
            <li>
              <Link to="/project" className="hover:text-red-700">
                {translations[language].OurProject}
              </Link>
            </li>
            <li>
              <Link to="/about-us" className="hover:text-red-700">
                {translations[language].aboutUs}
              </Link>
            </li>
            <li>
              <Link to="/contact" className="hover:text-red-700">
                {translations[language].ContactUs}
              </Link>
            </li>
          </ul>
        </div>

        {/* Google Map */}
        <div className="md:col-span-2 w-full h-40 md:h-48 lg:h-56">
          <iframe
            className="w-full h-full rounded-lg shadow-lg"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3819.715427646926!2d96.1739496!3d16.7831123!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTbCsDQ3JzAxLjIiTiA5NsKwMTAnMjYuMiJF!5e0!3m2!1sen!2smm!4v1620000000000!5m2!1sen!2smm"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
